import React from 'react';
import cn from 'clsx';

import Tooltip from '../../library/tooltip/tooltip';
import Typography from '../../library/typography/typography';
import StopwatchSolidIcon from '../../shared/icons/stopwatch-solid-icon';

import { useAemContent } from '../../shared/hooks/hooks';

import {
  AEM_CONTENT_IDS,
  AEM_CONTENT_PAGE_IDS
} from '../../shared/constants/cms';

import styles from './product-promo-countdown.scss';

interface ProductPromoCountdownProps {
  countdownText: string;
  showTooltip?: boolean;
}

function ProductPromoCountdown(props: ProductPromoCountdownProps) {
  const { countdownText, showTooltip } = props;

  const { aemTooltipsContent } = useAemContent(AEM_CONTENT_PAGE_IDS.global);

  const promoTooltip =
    aemTooltipsContent?.[AEM_CONTENT_IDS.promoOfferEnds]?.tipText;

  return (
    <span className={cn(styles['container'], 'product-promo-countdown')}>
      <StopwatchSolidIcon className={styles['icon']} />
      <Typography className={styles['text']} tag="span">
        Offer ends&nbsp;
        <time className={styles['date']} dateTime={countdownText}>
          {countdownText}
        </time>
      </Typography>
      {showTooltip && (
        <Tooltip className={styles['tooltip']} content={promoTooltip} />
      )}
    </span>
  );
}

export default ProductPromoCountdown;
